var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        {
          root: true,
          chatOpen: _vm.chatOpen,
          sidebarClose: _vm.sidebarClose,
          sidebarStatic: _vm.sidebarStatic
        },
        _vm.dashboardThemeClass,
        "sing-dashboard"
      ]
    },
    [
      _c("Sidebar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrap" },
        [
          _c("Header"),
          _vm._v(" "),
          _c(
            "v-touch",
            {
              staticClass: "content",
              attrs: { "swipe-options": { direction: "horizontal" } },
              on: { swipe: _vm.handleSwipe }
            },
            [
              _c(
                "transition",
                { attrs: { name: "router-animation" } },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }